export default __webpack_public_path__ + "static/media/oscer-pres-muscle-weakness.71bd3095.svg";